import model from "./assets/crown.glb";

import img1 from './assets/amenities/badminton.jpg';
import img2 from './assets/amenities/squash.jpg';
import img3 from './assets/amenities/Temple.jpg';
import img4 from './assets/amenities/spa.png';
import img5 from './assets/amenities/gym.jpg';
import img6 from './assets/amenities/banquet.jpg';
import img7 from './assets/amenities/indoor_game.jpg';
import img8 from './assets/amenities/board_game.jpg';
import img9 from './assets/amenities/kids_play_area.jpg';
import img10 from './assets/amenities/yoga_area.jpg';
// import img11 from './assets/amenities/gym.png';
// import img12 from './assets/amenities/deckarea.png';

import videoPoster from './assets/poster.jpg';

import wVideo from './assets/amenities/Walkthrough.mp4';

import imageTerrace from './assets/TERRACE FLOOR PLAN.jpg'
import image11A from './assets/11th Floor Amenities.jpg';
import image37A from './assets/37th Floor Amenities.jpg';
import imagegfLobby from './assets/ground_floor_lobby.jpg';
import imageP1 from './assets/basement 0 parking.jpg';

import loc1 from './assets/icons/bank.png';
import loc2 from './assets/icons/school.png';
import loc3 from './assets/icons/hospital.png';
import loc4 from './assets/icons/cinema.png';
import loc5 from './assets/icons/park.png';
import loc6 from './assets/icons/shoppingMall.png';
import loc7 from './assets/icons/train.png'

import slogo from './assets/slogo.png';
import majestiqueLogo from './assets/majestiqueLogo.jpg';

import rera from './assets/reralogo.png'

import posterLoading from './assets/loading.png';

import qrCodeImg from './assets/qrcode.jpg';

const amenities = [
    img1,img2,img3,img4,
    img5,img6,img7,img8,
    img9,img10
    // img11,img12
];

const locations = [
    {
        image:loc7,
        distance:"1.5 km",
        details:"Swargate Metro Station"
    },
    {
        image:loc1,
        distance:"1 km",
        details:"HDFC Bank and ICICI Bank"
    }, 
    {
        image:loc2,
        distance:"500 m",
        details:"Orchids The International School"
    }, 
    {
        image:loc3,
        distance:"2.4 km",
        details:"Ranka Hospital"
    },
    {
        image:loc4,
        distance:"3 km",
        details:"City Pride"
    }, 
    {
        image:loc5,
        distance:"2.8 km",
        details:"Saras Baug"
    }, 
    {
        image:loc6,
        distance:"1 km",
        details:"Kumar Pacific Mall"
    }
];
//TODO: Pointers and Images
const details = {

    qrCodeImg:qrCodeImg,
    qrLink:"https://maharerait.mahaonline.gov.in/ProjectSummaryView/ProjectSummaryQRCodeView?id=Q2VydGlmaWNhdGVObz1QNTIxMDAwNTQzNzkmU2NhbnR5cGU9UHJvbW90ZXJMb2dpblFSQ29kZQ==" ,
    crownLogo:slogo,
    majestiqueLogo:majestiqueLogo,
    projectName: "The Crown",
    projectAdd: "Majestique Landmarks",
    rera:"Maharera No. P52100054379",
    phone:"918346898989",
    email:"Thecrown@majestique.co.in",
    model:model,
    amenities:amenities,
    mapLink:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.6848887350225!2d73.8695784749624!3d18.49792728259127!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c18be4939703%3A0x6514f435db0488da!2sThe%20Crown%20by%20Majestique%20Landmarks!5e0!3m2!1sen!2sus!4v1713194420378!5m2!1sen!2sus",
    locations:locations,
    posterLoading:posterLoading,
    image11A:image11A,
    image37A:image37A,
    imagegfLobby:imagegfLobby,
    imageTerrace:imageTerrace,
    imageP1:imageP1,
    siteAddress:"The Crown by Majestique Landmarks, Plot No 389, PTS III, Gultekadi, Pune, Maharashtra 411037",
    corporateOffice:"9th Floor, Jawaharlal Nehru Rd, opposite Apsara Theatre, Guru Nanak Nagar, Pune, Maharashtra 411037, Tel: +91-20-26442770",
    reralogo:rera,
    wVideo:wVideo,
    videoPoster:videoPoster,

};

export default details;